__turbopack_context__.v({
  "card": "CoreValues-module__RQygIq__card",
  "description": "CoreValues-module__RQygIq__description",
  "grid": "CoreValues-module__RQygIq__grid",
  "iconWrapper": "CoreValues-module__RQygIq__iconWrapper",
  "title": "CoreValues-module__RQygIq__title",
  "values": "CoreValues-module__RQygIq__values",
});
